import { render, staticRenderFns } from "./VeHrJingtieModal.vue?vue&type=template&id=2ed37c31"
import script from "./VeHrJingtieModal.vue?vue&type=script&lang=js"
export * from "./VeHrJingtieModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports